// extracted by mini-css-extract-plugin
export default {"customMarginTopNegative4":"u1qvdDvX2bDgShczfraz","customMarginright2":"gvtp2PqesXfjQTz92xVJ","container":"oBPE5h4tc1N5DGjxvZgU"};